import { render, staticRenderFns } from "./cart-wholesale.component.vue?vue&type=template&id=9824224a&scoped=true&"
import script from "./cart-wholesale.component.vue?vue&type=script&lang=js&"
export * from "./cart-wholesale.component.vue?vue&type=script&lang=js&"
import style0 from "./cart-wholesale.component.vue?vue&type=style&index=0&id=9824224a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9824224a",
  null
  
)

export default component.exports